// extracted by mini-css-extract-plugin
module.exports = {"follow":"c46b06","followInner":"_9e1d80"};